/**
 * Try to use separate files in /components/
 *
 * IMPORTANT: If you want to use jQuery, make sure you enqueue it first.
 * Since it is only registered in the parent theme's actions.php
 */

import './components/breakpoint-change';
import './components/header-height';
import './components/sticky-header';
import './components/responsive-tables';
import './components/scroll-animate';
import './components/pagination';
